<template>
  <!-- 项目 -->
  <el-container>
    <el-aside width="200px" v-show="clickStatus">
      <div class="search">
        <el-input
          v-model="filterText"
          prefix-icon="el-icon-search"
          :placeholder="'搜索标题和ID...'"
          class="search_input"
        />
        <div class="search_btn">
          <i
            class="el-icon-menu"
            v-if="keyname == 'city'"
            @click="setKeyname('Service_Manager')"
          ></i>
          <i
            class="el-icon-user-solid"
            v-else-if="keyname == 'Service_Manager'"
            @click="setKeyname('city')"
          ></i>
        </div>         
      </div>
      <el-select
                  clearable
                  v-model="Service_Manager"
                  placeholder="请选择经理"
                  @change="getdata"
                >
                  <el-option :label="''" :value="''" />
                  <el-option
                    v-for="item in tboptions.fzr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-select
                  clearable
                  v-model="ServiceMan"
                  placeholder="请选择工程师"
                  @change="getdata"
                >
                  <el-option :label="''" :value="''" />
                  <el-option
                    v-for="item in tboptions.fzr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
      <el-menu
        :default-openeds="defalut"
        :default-active="defaluta"
        class="el-menu-vertical-demo"
      >
        <el-submenu v-for="(e, i) in data1" :key="i" :index="i + ''">
          <template slot="title">
            <i class="el-icon-caret-bottom"></i>

            <span>{{ e.local }}</span>
          </template>
          <el-menu-item-group>            
            <el-menu-item
              v-for="(item, ii) in e.list"
              :key="ii"
              :index="i + '-' + ii"
              @click="b4goto(item)"
            >
              <div class="ornav">
                <i class="el-icon-office-building"></i>
                <div>
                  {{ item.name + '-' + item.ctname }}
                  <!-- {{ i + '-' + ii }} -->
                </div>
              </div>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-aside>
    <div class="toggle-middle-col">
      <div
        class="tree-toggle"
        :style="clickStatus ? 'background:#e8edf7' : 'background:none'"
      >
        <span
          class="toggle-icon"
          :title="clickStatus ? '收起' : '展开'"
          @click="treeClickFun"
        >
          <!-- el-icon-arrow-right #e8edf7-->
          <i
            :class="clickStatus ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
          ></i>
        </span>
      </div>
    </div>
    <el-main>
      <div class="nav">
        <div
          class="navebox"
          v-for="(e, i) in data2"
          :key="i"
          :class="{ isactive: e.isactive }"
          @click="b4goto2(e)"
        >
          <div class="n">
            <div class="nl">
              <div class="name">
                <i v-if="e.isactive" class="el-icon-caret-bottom"></i>
                <i v-else class="el-icon-caret-right"></i>
                <span> {{ e.title }}</span>
              </div>
              <div class="ps" v-if="e.path != 'research'">
                <div class="jdbox">
                  <div class="jd" :style="{ width: e.ps + '%' }"></div>
                </div>
                {{ e.ps }}%
              </div>
            </div>
            <div class="nr">
              <img :src="e.ico" :alt="e.title" />
            </div>
          </div>
        </div>
      </div>
      <div class="project">
        <keep-alive>
          <router-view
            ref="sonMethod"
            :outWidth="clickStatus ? 200 : outWidth"
            :outHeight="outHeight"
          ></router-view>
        </keep-alive>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { GetProject, ppro_GetProjectPS,GetFZRlist } from '@api/api.js'
export default {
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.userInfo) || {}, // 用户登录信息
      name: this.$route.query.name,
      autoid: this.$route.query.autoid,
      filterText: '',
      path: 'pre',
      defalut: [], // 默认打开全部
      defaluta: '0', // 默认选中的项目
      ini: [], // 原始数据-加工city
      ini2: [], // 原始数据
      data1: [],
      data2: [
        {
          title: '项目准备',
          ps: 100,
          isactive: true,
          ico: require('@/assets/img/pic_zb_d1.png'),
          path: 'pre'
        },
        {
          title: '项目启动',
          ps: 75,
          isactive: false,
          ico: require('@/assets/img/pic_zb_d2.png'),
          path: 'start'
        },
        {
          title: '项目调研',
          ps: 75,
          isactive: false,
          ico: require('@/assets/img/pic_zb_d3.png'),
          path: 'research'
        },
        {
          title: '项目进度',
          ps: 75,
          isactive: false,
          ico: require('@/assets/img/pic_zb_d4.png'),
          path: 'progress'
        },
        {
          title: '项目上线',
          ps: 75,
          isactive: false,
          ico: require('@/assets/img/pic_zb_d5.png'),
          path: 'online'
        },
        {
          title: '项目验收',
          ps: 75,
          isactive: false,
          ico: require('@/assets/img/pic_zb_d6.png'),
          path: 'acceptance'
        }
      ],
      keyname: 'city',
      clickStatus: true,
      outHeight: 0,
      outWidth: 0,
      Service_Manager: '',
      ServiceMan: '',
      tboptions: {
        fzr: []
      },
       cbd: this.$route.query.cbd,
      ced: this.$route.query.ced,
    }
  },
  created() {
    if (this.$route.path.indexOf('/') > -1) {
      const arr = this.$route.path.split('/')
      let p = arr[arr.length - 1]
      this.data2.forEach(e => {
        e.isactive = e.path == p
      })
    }
    GetProject({ name: this.userInfo.name }).then(res => {
      this.ini2 = res.list
      this.getdata()
    })
    this.getjd()
    this._GetFZRlist()
  },
  watch: {
    filterText(val) {
      this.getdata2()
    },
    Service_Manager(val) {
      this.getdata2()
    },
    ServiceMan(val) {
      this.getdata2()
    },
    '$route.query': {
      handler(newVal, oldVal) {
        //判断newVal有没有值监听路由变化
        this.name = newVal.name
        this.autoid = newVal.autoid
        // alert(this.autoid)
        this.getjd()
      },
      deep: true
    }
  },
  methods: {
    getdata2(){
      if (this.filterText||this.Service_Manager||this.ServiceMan) {
        this.data1 = [
          {
            show: true,
            local: '搜索结果',
            list:[]
          }
        ]
        
        this.data1[0].list = this.ini2.filter(e => {
          if (this.filterText)
          return (
            e.name.indexOf(this.filterText) > -1 ||
            e.ctname.indexOf(this.filterText) > -1 ||
            e.ServiceMan.indexOf(this.filterText) > -1 ||
            (e.ServiceMan2 && e.ServiceMan2.indexOf(this.filterText) > -1) ||
            (e.ServiceMan3 && e.ServiceMan3.indexOf(this.filterText) > -1) ||
            e.Saler.indexOf(this.filterText) > -1 ||
            e.Service_Manager.indexOf(this.filterText) > -1
          )
           else {
            return true
          }
        }).filter(e => {
          if (this.ServiceMan && this.Service_Manager) {
            return (
              e.Service_Manager.indexOf(this.Service_Manager) > -1 ||
              e.ServiceMan.indexOf(this.ServiceMan) > -1 ||
                (e.ServiceMan2 &&
                  e.ServiceMan2.indexOf(this.ServiceMan) > -1) ||
                (e.ServiceMan3 && e.ServiceMan3.indexOf(this.ServiceMan) > -1)
            )
          } else if (this.Service_Manager)
            return e.Service_Manager.indexOf(this.Service_Manager) > -1
          else if (this.ServiceMan)
            return (
              e.ServiceMan.indexOf(this.ServiceMan) > -1 ||
              (e.ServiceMan2 && e.ServiceMan2.indexOf(this.ServiceMan) > -1) ||
              (e.ServiceMan3 && e.ServiceMan3.indexOf(this.ServiceMan) > -1)
            )
          else {
            return true
          }
        })
         this.defalut.push('0')  
      } else {
        this.data1 = JSON.parse(JSON.stringify(this.ini))
      }
    },
    _GetFZRlist() {
      GetFZRlist().then(res => {
        this.tboptions.fzr = res.list.map(e => {
          return {
            value: e.empname,
            label: e.empname
          }
        })
      })
    },
    treeClickFun() {
      if (this.clickStatus) {
        this.clickStatus = false
        // this.$emit("treeClickFun",this.clickStatus)
      } else {
        this.clickStatus = true
        // this.$emit("treeClickFun",this.clickStatus)
      }
    },
    // 获取各个项目的进度
    getjd() {
      if (this.autoid) {
        ppro_GetProjectPS({ autoid: this.autoid }).then(res => {
          this.data2.forEach((e, i) => {
            e.ps = res.list[0]['ps' + (i + 1)]
          })
        })
      }
    },
    setKeyname(k) {
      this.keyname = k
      this.getdata()
    },
    getdata() {
      let data = [],
        local = []
      this.ini2.forEach(e => {
        // e.pic = require('@/assets/img/pro1.png')
        if (local.indexOf(e[this.keyname]) == -1) {
          local.push(e[this.keyname])
          data.push({
            show: true,
            local: e[this.keyname],
            list: [e]
          })
          // 默认打开全部
          this.defalut.push((data.length-1) + '')
        } else {
          data[local.indexOf(e[this.keyname])].list.push(e)
        }
        // 默认选中的项目
        if (this.autoid == e.autoid) {
          this.defaluta =
            local.indexOf(e[this.keyname]) +
            '-' +
            (data[local.indexOf(e[this.keyname])].list.length - 1)
        }
      })
      this.ini = data
      this.data1 = JSON.parse(JSON.stringify(this.ini))
    },
    b4goto(item) {
      let change = false
      if (this.$refs.sonMethod.ini && this.$refs.sonMethod.tableData) {
        if (this.$refs.sonMethod.tableData.length > 0) {
          let autoidarr = this.$refs.sonMethod.tableData.map(e => {
            return e.autoid
          })
          let ss = this.$refs.sonMethod.ini.filter(e => {
            return autoidarr.indexOf(e.autoid) > -1
          })

          change = !(
            JSON.stringify(ss) == JSON.stringify(this.$refs.sonMethod.tableData)
          )
        }
      }
      if (
        ['/main/project/research', '/main/project/progress'].indexOf(
          this.$route.path
        ) > -1 &&
        change
      ) {
        this.$confirm('确认已经保存数据了吗吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.name = item.name + '-' + item.ctname
          this.autoid = item.autoid
          this.cbd = item.cbd
          this.ced = item.yj_jadate ||item.ced
          this.goto()
        })
      } else {
        this.name = item.name + '-' + item.ctname
        this.autoid = item.autoid
        this.cbd = item.cbd
        this.ced = item.yj_jadate ||item.ced
        this.goto()
      }
    },
    b4goto2(item) {
      this.data2.forEach(e => {
        e.isactive = false
      })
      item.isactive = true
      this.path = item.path
      this.goto()
    },
    goto() {
      let path = '/main/project/' + this.path
      let query = {
        autoid: this.autoid,
        cbd: this.cbd,
        ced: this.ced,
        name: this.name
      }
      this.$router.push({ path: path, query: query })
    }
  }
}
</script>

<style scoped lang="scss">
.el-container {
  .el-aside {
    background: #f4f5f7 url('~@/assets/img/daohang_bg.png') center bottom
      no-repeat;
    padding: 10px;
    height: calc(100vh - 60px);
    .search {
      width: 91%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 27px;
      margin: 10px 10px;
      // position: absolute;
      // top: 0;
      // left: 0;
      /deep/.search_input {
        margin-right: 0;

        .el-input__inner {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-size: 13px;
          margin-top: 10px;
          // margin-left: 0.22rem;
          height: 36px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          margin-bottom: 11px;
          background: #dde0e6;
          border-radius: 6px;
          border: none;
        }
        .el-input__inner::placeholder {
          color: #7d7d7d;
        }
      }
      .search_btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 49px;
        height: 36px;
        border-radius: 0px 5px 5px 0px;
        z-index: 1000;
        i {
          width: 20px;
          height: 20px;
          font-size: 20px;
        }
      }
    }
    /deep/ .el-menu {
      background: none !important;
      padding: 0;
      .el-submenu__title {
        font-size: 15px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #282828;
        padding: 0 !important;
      }
      .el-menu-item {
        padding: 0 !important;
        .ornav {
          width: 100%;
          display: flex;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          white-space: normal;
          line-height: 18px;
          padding: 10px;
        }
      }
      .el-menu-item.is-active,
      .el-menu-item:hover {
        background: none;
        .ornav {
          color: #fff;
          background: #007ff5;
          border-radius: 21px;
          i {
            color: #fff;
          }
        }
      }
    }
  }
  .toggle-middle-col {
    background: #f4f5f7;
    .tree-toggle {
      display: flex;
      top: 0;
      bottom: 0;
      left: 0;
      width: 15px;
      background: rgb(232, 237, 247);
      height: 100%;
      align-items: center;
      position: relative;
      .toggle-icon {
        display: inline-flex;
        width: 100%;
        height: 30px;
        cursor: pointer;
        // border-radius: 2px 0 0 2px;
        align-items: center;
        position: absolute;
        background: #4e89f8;
        color: #fff;
      }
    }
  }
  .el-main {
    background: url('~@/assets/img/BG.png') center bottom/100% 100% no-repeat;
    position: relative;

    .nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .navebox {
        width: calc(100% / 6 - 10px);
        height: 30px;
        // height: 90px;
        background: #ffffff;
        border: 1px solid transparent;
        box-shadow: 1px 2px 21px 0px rgba(167, 167, 167, 0.32);
        border-radius: 10px;
        cursor: pointer;
        position: relative;
        .n {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          padding: 10px;
          .nl {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .name {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              line-height: 45px;
            }
            .ps {
              .jdbox {
                display: inline-block;
                width: 90px;
                height: 4px;
                background: #e5eaef;
                border-radius: 2px;
                display: none;
                .jd {
                  background: #0abc66;
                  height: 4px;
                  border-radius: 2px;
                }
              }
            }
          }
          .nr {
            display: none;
            img {
              height: 80px;
            }
          }
        }
      }
      .navebox.isactive {
        border: 1px solid rgba(0, 127, 245, 1);
        .nl {
          .name {
            color: #124abe;
          }
        }
        ::after {
          content: '';
          width: 0;
          height: 0;
          border-top: 30px solid rgba(0, 127, 245, 1);
          border-right: 50px solid transparent;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
    .project {
      // background: #fff;
      height: calc(100vh - 100px - 40px);
    }
  }
}
</style>
